import { spCandidatAffiliationLocs } from './candidate-affiliations/candidate-affiliations.locs';
import { candidateExternalIdsLocs } from './candidate-external-ids/candidate-external-ids.locs';
import {
	spAddressFormLocs,
	spSharedAddressFormLocs,
} from './mailing-addresses/sp-address-form-locs';

export const candidateSummaryModuleLocs = {
	...candidateExternalIdsLocs,
	...spCandidatAffiliationLocs,
	...spAddressFormLocs,
	...spSharedAddressFormLocs,
};
